import { createCollectionReducer } from 'ext/lib/collections';
import { TYPE } from './actions';
import type { AccountsState } from './types';

export default createCollectionReducer(TYPE);

/** SELECTORS */

export const selectUserAccounts = <T extends { accounts: AccountsState }>(
  state: T
): AccountsState => state.accounts || {};

export const selectHasMultipleAccounts = <
  T extends { accounts: AccountsState },
>(
  state: T
): boolean => Object.keys(selectUserAccounts(state)).length > 1;
